<template>
    <el-card>
      <div
        slot="header"
        class="clearfix"
      >
        <span>Munkaidő kimutatás</span>
      </div>
      <div v-loading="loading" style="min-height: 81px;">
        <table-filter
          v-if="filterConfig"
          :config="filterConfig"
          action="worktimeReport/fetchAll"
        />

        <el-button
          style="float: right; margin-top: -90px;"
          :loading="downloadLoading"
          icon="el-icon-download"
          @click="download"
        >
          Letöltés
        </el-button>
      </div>
      <worktime-list style="margin-top: 30px"/>
    </el-card>
</template>

<script>
import WorktimeList from '../../components/reports/worktime/List';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    WorktimeList,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
      downloadLoading: false,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async download() {
      this.downloadLoading = true;
      try {
        const excel = await axios({
          url: `api/reports/worktime/download?${this.$store.getters['worktimeReport/filterString']}`,
          method: 'POST',
          responseType: 'blob',
          data: {
            sortby: this.$store.getters['worktimeReport/sorting'].prop,
            sorttype: this.$store.getters['worktimeReport/sorting'].prop.order == 'ascending' ? 'asc' : 'desc',
          },
        });
        saveAs(excel, `worktimereport.xlsx`);
      } catch (e) {
      }
      this.downloadLoading = false;
    },

    async setConfig() {
      let users = this.$store.getters['user/users'];
      if (!users.length) {
        await this.$store.dispatch('user/fetchRepresentatives');
        users = this.$store.getters['user/representatives'];
        console.log(users)
      }
      let locations = this.$store.getters['location/locations'];
      if (!locations.length) {
        await this.$store.dispatch('location/fetchAll');
        locations = this.$store.getters['location/locations'];
      }
      this.filterConfig = [
        {
          type: 'select',
          options: users,
          name: 'representative_user',
          label: 'Képviselő',
          labelCallback: user => user && user.last_name + ' ' + user.first_name || '',
          valueKey: 'id',
          defaultSearch: true
        },
        {
          type: 'select',
          options: locations,
          name: 'location',
          label: 'Terület',
          labelCallback: location => location && location.value || '',
          valueKey: 'id',
        },
        {
          type: 'dateRange',
          name: 'daterange',
          label: 'Időszak',
        },
      ];
    }
  }
};
</script>
